import React, {memo, FC} from "react";
import {Space, Tag, Tooltip} from "antd";
import {CheckCircleFilled} from "@ant-design/icons";
import {green} from "@ant-design/colors";
import {CourseVisibilityResult, GetCourseByIdQuery} from "../../../generated/graphql";
import i18n from "../../../services/i18n";
import RenderVisibility from "../../../views/TableColumnRenderers/RenderVisibility";

type VisibilityAsTagProps = {
    visibility?: GetCourseByIdQuery["courseById"]["visibility"];
    blockBookingOnline: boolean;
    sizeMultiplier?: number;
    style?: React.CSSProperties;
};

const VisibilityAsTag: FC<VisibilityAsTagProps> = ({visibility, blockBookingOnline, sizeMultiplier = 1, style}) => {
    if (visibility?.visibleForAll) {
        return (
            <Tooltip title={i18n.containers.courses.Courses.visibility.visibleForAllDescription()}>
                <Tag
                    color="green"
                    style={{
                        ...style,
                        paddingTop: 2,
                    }}
                    icon={<CheckCircleFilled style={{color: green[3]}} />}
                >
                    {i18n.containers.courses.Courses.visibility.visibleForAll()}
                </Tag>
            </Tooltip>
        );
    }

    return (
        <Tag color="red" style={style}>
            <Space>
                <div
                    style={{
                        lineHeight: 1,
                    }}
                >
                    {i18n.views.TableColumnTitles.visibility()}
                </div>
                <RenderVisibility
                    courseVisibilityResult={visibility as CourseVisibilityResult}
                    blockBookingOnline={blockBookingOnline}
                    sizeMultiplier={sizeMultiplier}
                    style={{marginTop: 2, marginBottom: -2}}
                />
            </Space>
        </Tag>
    );
};

export default memo(VisibilityAsTag);
